export interface FitterStatistic {
  brandId: string;
  id: string;
  periodType: string;
  period: string;
  insuranceStat: { [insurerId: string]: FitterInsuranceStatisticDetails };
}

export interface FitterInsuranceStatisticDetails {
  total: number;
  replace: number;
  repair: number;
  repairRatio: number;
  nbrDossier: number;
}

export interface usersByProfileStatistic {
  key: string;
  count: number;
}
